// extracted by mini-css-extract-plugin
export default {"contentHolder":"gRYkmk","contentFallback":"WR2Rrl","mobile":"uKqWB5"};